// IdeasDashboard.js
import React, { useEffect, useState } from "react";
import IdeasForm from "./IdeasForm";
import "./IdeasDashboard.css";
import bgsky from "../../utilities/bgsky.png";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../../utilities/logo-png.png";

import {
  Modal,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Button,
  DialogContent,
  DialogActions,
  DialogTitle,
  Dialog,
} from "@mui/material";

const IdeasDashboard = (props) => {
  const [ideas, setIdeas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [openAll, setOpenAll] = useState(false);
  const [selectedIdea, setSelectedIdea] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const fetchIdeas = async () => {
    try {
      const res = await fetch("https://hr-backend-72v1.onrender.com/getideas");
      if (!res.ok) throw new Error("Failed to fetch ideas");
      const data = await res.json();
      console.log(data);
      setIdeas(data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchIdeas();
  }, []);

  const handleShareNewClick = () => {
    setShowForm(true);
  };

  const handleOpenAll = () => {
    if (props.user.role === "HR" || props.user.role === "Executive") {
      fetchIdeas();
      setOpenAll(true);
    }
  };
  const handleOpenDialog = (idea) => {
    setSelectedIdea(idea);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedIdea(null);
  };

  if (loading) return <div>Loading ideas...</div>;
  if (error) return <div>Error: {error}</div>;

  if (showForm)
    return (
      <IdeasForm
        handleFormClose={() => {
          setShowForm(false);
          fetchIdeas();
        }}
        user={props.user}
      />
    );

  const displayedIdeas = ideas.slice(0, 4);

  return (
    <div>
      <div
        className="ideas-container"
        style={{
          backgroundImage: `url(${bgsky})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {!openAll && (
          <>
            <div className="center-node" onClick={handleOpenAll}>
              IDEAS
            </div>

            {displayedIdeas.map((idea, index) => (
              <div
                key={idea._id || index}
                className={`idea-node idea-${index}`}
                onClick={() => handleOpenDialog(idea)}
              >
                <div className="idea-title">
                  {(idea.title || "Untitled").split(" ").slice(0, 4).join(" ") +
                    ((idea.title || "").split(" ").length > 4 ? "..." : "")}
                </div>

                {/* <div className="idea-info">{idea.category}</div> */}
              </div>
            ))}
            <div className="idea-node share-node" onClick={handleShareNewClick}>
              + Share New Idea
            </div>
          </>
        )}
        {openAll && (
          <TableContainer
            component={Paper}
            className="leaveContainer"
            style={{
              position: "relative",
              overflow: "auto",
              maxHeight: "82vh",
              paddingRight: "0.5rem",
            }}
          >
            {/* <button
              className="close-btn"
              onClick={() => setOpenAll(false)}
              aria-label="Close"
            >
              ×
            </button> */}
            <div
              // style={{ position: "absolute", top:0, right: 0, padding: "15px 5px" }}
              className="close-btn"
            >
              <Button onClick={() => setOpenAll(false)}>
                <CloseIcon />
              </Button>
            </div>
            <h4 className="myTableHeader animate__animated animate__lightSpeedInLeft">
              ALL IDEAS 💡
            </h4>
            <Table
              sx={{ minWidth: 650 }}
              className="leaveTable"
              // style={{overflow: "scroll !important" }}
            >
              <TableHead>
                <TableRow>
                  <TableCell className="myTableHeadCells">
                    <span className="myTableHeadSpan">Title</span>
                  </TableCell>
                  <TableCell className="myTableHeadCells">
                    <span className="myTableHeadSpan">Category</span>
                  </TableCell>
                  <TableCell className="myTableHeadCells">
                    <span className="myTableHeadSpan">Date</span>
                  </TableCell>
                  <TableCell className="myTableHeadCells">
                    <span className="myTableHeadSpan">Name</span>
                  </TableCell>
                  {/* <TableCell className="myTableHeadCells">
                    <span className="myTableHeadSpan">Email</span>
                  </TableCell> */}
                  {/* <TableCell className="myTableHeadCells">
                    <span className="myTableHeadSpan">Votes</span>
                  </TableCell> */}
                  {/* <TableCell className="myTableHeadCells">
                    <span className="myTableHeadSpan">Status</span>
                  </TableCell> */}

                  <TableCell className="myTableHeadCells" align="right">
                    <span className="myTableHeadSpan">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ideas?.map((idea) => (
                  <TableRow key={idea._id}>
                    <TableCell sx={{ fontSize: "large" }}>
                      {idea.title}
                    </TableCell>
                    <TableCell sx={{ fontSize: "large" }}>
                      {idea.category}
                    </TableCell>
                    <TableCell sx={{ fontSize: "large" }}>
                      {new Date(idea?.date).toISOString().split("T")[0]} ⏱&nbsp;
                      {new Date(idea?.date).toLocaleTimeString("en-US", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </TableCell>
                    <TableCell sx={{ fontSize: "large" }}>
                      {idea.anonymous ? "Anonymous" : idea.name}
                    </TableCell>
                    {/* <TableCell sx={{ fontSize: "large" }}>
                      {idea.anonymous ? "-" : idea.email}
                    </TableCell> */}
                    {/* <TableCell sx={{ fontSize: "large" }}>
                      {idea.vote}
                    </TableCell> */}
                    {/* <TableCell sx={{ fontSize: "large" }}>
                      {idea.status}
                    </TableCell> */}

                    <TableCell align="right" sx={{ fontSize: "large" }}>
                      <Button onClick={() => handleOpenDialog(idea)}>
                        View Idea
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        {dialogOpen && (
          <Dialog
            open={dialogOpen}
            onClose={handleCloseDialog}
            maxWidth="md"
            fullWidth
          >
            <DialogActions
              sx={{ position: "absolute", right: 0, padding: "15px 5px" }}
            >
              <Button onClick={handleCloseDialog}>
                <CloseIcon />
              </Button>
            </DialogActions>
            <Table
              sx={{ minWidth: 650 }}
              className="leaveTable"
              style={{ overflow: "scroll" }}
            >
              <TableHead>
                <TableRow>
                  <TableCell className="myTableHeadCells">
                    <span className="myTableHeadSpan">Name</span>
                  </TableCell>
                  <TableCell className="myTableHeadCells">
                    <span className="myTableHeadSpan">Email</span>
                  </TableCell>
                  {/* <TableCell className="myTableHeadCells">
                    <span className="myTableHeadSpan">Status</span>
                  </TableCell> */}
                  <TableCell className="myTableHeadCells">
                    <span className="myTableHeadSpan">Date</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ fontSize: "large" }}>
                    {selectedIdea?.anonymous ? "Anonymous" : selectedIdea?.name}
                  </TableCell>
                  <TableCell sx={{ fontSize: "large" }}>
                    {selectedIdea?.anonymous ? "-" : selectedIdea?.email}
                  </TableCell>
                  {/* <TableCell sx={{ fontSize: "large" }}>
                    {selectedIdea?.status}
                  </TableCell> */}
                  <TableCell>
                    {new Date(selectedIdea.date).toISOString().split("T")[0]}{" "}
                    ⏱&nbsp;
                    {new Date(selectedIdea.date).toLocaleTimeString("en-US", {
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    })}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <div className="dialogTop">
              <div className="dialogLeft">
                <DialogTitle className="dialogHeading">Title</DialogTitle>
                <p className="dialogtext">💡 {selectedIdea?.title || "Idea"}</p>
                <DialogTitle className="dialogHeading">Category</DialogTitle>
                <p className="dialogtext">{selectedIdea?.category}</p>
              </div>
              <div className="dialogRight">
                <img src={logo} width="220" height="220" alt="GROWTH GUILD" />
              </div>
            </div>
            <DialogTitle className="dialogHeading">Idea</DialogTitle>
            <DialogContent className="dialogtextReport">
              {selectedIdea?.idea}
            </DialogContent>
          </Dialog>
        )}
      </div>
    </div>
  );
};

export default IdeasDashboard;
